import { gsap } from 'gsap';
import { cmsNoImage } from './general';
import tplWebshopListFeaturedImage from '../templates/webshop_list_featured_image.pug';

/**
 * Switch between featured images with crossfade effect
 * 
 * @param {string|HTMLElement} imgContainer - Featured image container HTML element or CSS selector
 * @param {object} options - Image settings
 * @param {null|object} [options.header_img=null] - Header image data (destkop image)
 * @param {null|object} [options.header_img_mobile=null] - Header image data (mobile image)
 * @param {number} [options.speed=0.4] - Image crossfade speed (in seconds)
 * @param {string} [options.ease=linear] - Image crossfade ease (any gsap easing type)
 * 
 * @returns {void}
 */
export const switchProductListFeaturedImage = (imgContainer, options = {}) => {
  const _defaults = {
    header_img: null,
    header_img_mobile: null,
    speed: 0.4,
    ease: 'linear',
  };
  const opts = { ..._defaults, ...options };

  const containerEl = (typeof imgContainer === 'string') ? document.querySelector(imgContainer) : imgContainer;
  const imgEl = containerEl.querySelector('img:not(.position-absolute)');
  const newImageClassnames = ['position-absolute', 'zi-2', 'top-0', 'start-0'];

  let imgHtml = cmsNoImage('wide', {
    theme: 'dark',
    classname: `d-blok w-100 h-auto ${newImageClassnames.join(' ')}`,
    styles: 'opacity: 0',
  });
  
  if (opts.header_img) {
    imgHtml = tplWebshopListFeaturedImage({
      headerImg: opts.header_img,
      headerImgMobile: opts.header_img_mobile,
      classname: `d-blok w-100 h-auto ${newImageClassnames.join(' ')}`,
      styles: 'opacity: 0',
    });
  }
  containerEl.insertAdjacentHTML('beforeend', imgHtml);
  const newImageEl = containerEl.querySelector('img.position-absolute');

  gsap.timeline({
    onComplete: () => {
      // console.log('complete timeline');
      newImageClassnames.forEach(classname => newImageEl.classList.remove(classname));
      imgEl.closest('picture').remove();
    }
  })
    .fromTo(newImageEl, { opacity: 0 }, { opacity: 1, duration: opts.speed, ease: opts.ease })
    .fromTo(imgEl, { opacity: 1 }, { opacity: 0, duration: 0.1 });

  // const containerEl = (typeof imgContainer === 'string') ? document.querySelector(imgContainer) : imgContainer;
  // const containerElRect = containerEl.getBoundingClientRect();
  // const imgEl = containerEl.querySelector('picture:not(.position-absolute)');

  // if (opts.header_img && typeof opts.header_img.src !== 'undefined') {
    
  //   // ignore same image
  //   if (imgEl && imgEl.querySelector('img').getAttribute('src') === opts.header_img.src) {
  //     return;
  //   }

  //   containerEl.style.height = (imgEl) ? `${containerElRect.height}px` : '0px';
  //   containerEl.classList.remove('d-none');
  //   const classname = ['position-absolute', 'top-0', 'left-0', 'zi-2'];
  //   const imgHtml = tplWebshopListFeaturedImage({
  //     headerImg: opts.header_img,
  //     headerImgMobile: opts.header_img_mobile,
  //     classname,
  //     styles: 'opacity: 0;',
  //   });
  //   containerEl.insertAdjacentHTML('beforeend', imgHtml);
  //   const newImgEl = containerEl.querySelector('picture.position-absolute');
  //   const newImgElRect = newImgEl.getBoundingClientRect();
  //   const tl = gsap.timeline({
  //     onComplete: () => {
  //       containerEl.style.height = 'auto';
  //       if (imgEl) {
  //         imgEl.parentNode.removeChild(imgEl);
  //       }
  //       classname.forEach(cn => newImgEl.classList.remove(cn));
  //     }
  //   });
  //   if (imgEl) {
  //     tl.fromTo(imgEl, { opacity: 1 }, { opacity: 0, duration: opts.speed, ease: opts.ease}, 0)
  //   } else {
  //     tl.fromTo(containerEl, { height: 0 }, { height: newImgElRect.height, duration: opts.speed, ease: opts.ease }, 0);
  //   }
  //   tl.fromTo(newImgEl, { opacity: 0 }, { opacity: 1, duration: opts.speed, ease: opts.ease}, 0);
  // } else {
  //   if (imgEl) {
  //     gsap.timeline({
  //       onComplete: () => {
  //         imgEl.parentNode.removeChild(imgEl);
  //         containerEl.classList.add('d-none');
  //       }
  //     })
  //       .to(containerEl, { height: 0, duration: opts.speed, ease: opts.ease });
  //   }
  // }
};

/**
 * Count active parameter filters
 * 
 * @param {object[]} paramGroupList - Parameter group list from backend
 * 
 * @returns {number}
 */
export const countCheckedParamFilters = (paramGroupList) => {
  let res = 0;
  if(!Array.isArray(paramGroupList))
    return res;
  paramGroupList.forEach(paramGroup => {
    paramGroup.parameters.forEach(param => {
      if (param.checked) {
        res ++;
      }
    });
  });
  return res;
};

export const openFilterPanel = (panelEl, options = {}) => {
  const _defaults = {
    speed: 0.6,
    ease: 'power2.inOut',
    backdropId: 'filterBackdrop',
  };
  const opts = { ..._defaults, ...options };

  // panel element
  panelEl.classList.remove('d-none');
  panelEl.classList.add('position-fixed', 'top-0', 'left-0', 'bottom-0', 'zi-11', 'shadow');
  gsap.fromTo(panelEl, { x: '-100%' }, { x: 0, duration: opts.speed, ease: opts.ease });

  // parent element
  const parentEl = panelEl.parentNode;

  // disable page scroll
  document.body.style.overflow = 'hidden';
  
  // backdrop
  if (!document.querySelector(`#${opts.backdropId}`)) {
    // document.body.insertAdjacentHTML('beforeend', `<div class="position-fixed top-0 left-0 w-100 h-100 zi-10 bg-texture-dark" id="${opts.backdropId}"></div>`);
    parentEl.insertAdjacentHTML('beforeend', `<div class="position-fixed top-0 left-0 w-100 h-100 zi-10 bg-texture-dark" id="${opts.backdropId}"></div>`);
  }
  gsap.fromTo(`#${opts.backdropId}`, { opacity: 0 }, { opacity: 0.9, duration: opts.speed / 2, ease: 'linear' });
};

export const closeFilterPanel = (panelEl, options = {}) => {
  const _defaults = {
    animation: true,
    speed: 0.6,
    ease: 'power2.inOut',
    backdropId: 'filterBackdrop',
  };
  const opts = { ..._defaults, ...options };
  const backdropEl = document.querySelector(`#${opts.backdropId}`);

  // enable page scroll
  document.body.style.overflow = '';

  if (!opts.animation) {
    // reset without animation
    if (backdropEl) {
      backdropEl.parentNode.removeChild(backdropEl);
    }
    panelEl.classList.add('d-none');
    panelEl.classList.remove('position-fixed', 'top-0', 'left-0', 'bottom-0', 'zi-10', 'shadow');
    return;
  }

  const tl = gsap.timeline({
    onComplete: () => {
      gsap.set(panelEl, { clearProps: 'all' });
      panelEl.classList.add('d-none');
      panelEl.classList.remove('position-fixed', 'top-0', 'left-0', 'bottom-0', 'zi-10', 'shadow');
      if (backdropEl) {
        backdropEl.parentNode.removeChild(backdropEl);
      }
    }
  });
  tl.fromTo(panelEl, { x: 0 }, { x: '-100%', duration: opts.speed, ease: opts.ease }, 0);
  if (backdropEl) {
    tl.fromTo(backdropEl, { opacity: 0.9 }, { opacity: 0, duration: opts.speed / 2, ease: 'linear' }, 0);
  }
};
